/**
 * Helpdesk konfiguráció — Natív rPI ERP Helpdesk Widget (v2)
 *
 * v1: Google Apps Script iframe
 * v2: Natív React + NestJS backend → Google Sheets
 */

export const HELPDESK_CONFIG = {
  /**
   * Helpdesk engedélyezve.
   *
   * 🔴 KIKAPCSOLVA (2026-08-11, 🔵-döntés): a Google-integráció halasztva, a
   * service-account kulcs törlésre megy. Kredencial nélkül a BE mock-ágra esik
   * (`google-sheets.service.ts` → `appendRow` `return 999`), így a bejelentés
   * "sikerül", de NYOM NÉLKÜL elvész — ez rosszabb, mint ha nem is lenne gomb.
   *
   * ⚠️ Ez BUILD-IDŐBEN rögzített, kliens-oldali kapcsoló: nem per-tenant és nem
   * környezet-szintű (a BE `GET /helpdesk/config` nem ad vissza `enabled` mezőt),
   * tehát a `false` egy build MINDEN telepítésére vonatkozik.
   *
   * Visszakapcsolás: `true` — a belépő (FAB-sor · Ctrl+Shift+H · badge · title)
   * egyben visszajön; a `UnifiedFAB.spec.tsx` pozitív kontrolljai ezt mérik.
   */
  enabled: false,

  /** Drawer szélessége desktop-on (px) */
  drawerWidth: 420,

  /** Maximum screenshot szám */
  maxScreenshots: 3,

  /** Maximum kép szélesség (resize ha nagyobb) */
  maxImageWidth: 1600,

  /** Duplikátum keresés debounce (ms) */
  duplicateDebounce: 800,

  /** Bejelentők listája (shared account módban) */
  reporters: ['Zsuzsi', 'Zoli', 'Javo', 'Peti', 'Attila'],

  /** ERP modulok listája */
  modules: [
    'Bejelentkezés',
    'Főoldal / Dashboard',
    'Bérlés',
    'Értékesítés / POS',
    'Szerviz / Munkalap',
    'Készlet / Raktár',
    'Partner kezelés',
    'Számlázás',
    'Pénztár / Kassza',
    'Járművek',
    'Árajánlat',
    'Riportok',
    'Beállítások',
    'Egyéb',
  ],

  /** Súlyossági szintek (bug) */
  severity: ['Kritikus', 'Magas', 'Közepes', 'Alacsony'],

  /** Prioritási szintek (feature) */
  priority: ['Sürgős', 'Fontos', 'Jó lenne', 'Ötlet'],

  /** Típus konfigurációk */
  types: [
    { value: 'bug' as const, label: 'Hiba', sheet: 'Hibák', color: 'red' },
    { value: 'feature' as const, label: 'Fejlesztési igény', sheet: 'Igények', color: 'blue' },
    { value: 'question' as const, label: 'Kérdés', sheet: 'Kérdések', color: 'green' },
  ],

  /** Shared account role-ok (ezeknél dropdown jelenik meg, nem auto-fill) */
  sharedAccountRoles: ['ADMIN', 'OPERATOR', 'SUPER_ADMIN'],

  /** Backend API base (helpdesk endpointok) */
  apiBase: '/helpdesk',
} as const;

/**
 * ERP route → Helpdesk modul mapping
 * Az aktuális URL alapján automatikusan kitölti a "Modul" mezőt
 */
export const ROUTE_MODULE_MAP: Record<string, string> = {
  '/rental': 'Bérlés',
  '/sales': 'Értékesítés / POS',
  '/worksheet': 'Szerviz / Munkalap',
  '/inventory': 'Készlet / Raktár',
  '/partners': 'Partner kezelés',
  '/invoice': 'Számlázás',
  '/cash': 'Pénztár / Kassza',
  '/vehicles': 'Járművek',
  '/quotes': 'Árajánlat',
  '/reports': 'Riportok',
  '/settings': 'Beállítások',
  '/dashboard': 'Főoldal / Dashboard',
};

/**
 * Az aktuális route-ból kitalálja a modul nevet
 */
export function detectModule(pathname: string): string {
  for (const [prefix, module] of Object.entries(ROUTE_MODULE_MAP)) {
    if (pathname.startsWith(prefix)) return module;
  }
  return '';
}
